import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const ExecutingStageAcceptedTimeCellContent: React.FC<
	ExecutingStageAcceptedTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const { content, backgroundColor } = useMemo(() => {
		const timestamp = item?.executingStages?.accepted?.timestamp;
		const content =
			timestamp && dateFns
				? dateFns.formatTime(timestamp, {
						formatTime: "HH:mm:ss",
						isTimezone: true,
				  })
				: "";
		const backgroundColor = timestamp ? "#4CAF50" : undefined;
		return { content, backgroundColor };
	}, [item?.executingStages?.accepted?.timestamp, dateFns]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutingStageAcceptedTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutingStageAcceptedTimeCellContent;
